// Badge суммарных непрочитанных. SPEC pwa-shell §4.6 (инв.3, FR-DELIVERY-03).
//
// Badge = АБСОЛЮТНОЕ суммарное число непрочитанных по всем чатам (не дельта чата). Источник числа —
// снаружи (client-store/app-ui знают сумму; SW берёт `PushPayload.unreadTotal`). pwa-shell лишь
// отражает его на иконке через W3C Badging API, деградируя в no-op там, где API нет (§4.6).
/**
 * Нормализует суммарный счётчик к значению, пригодному для `setAppBadge`. Чистая функция.
 * Правила: ноль/отрицательное/NaN → 0 (badge снимается); дробное → floor (счётчик целочислен).
 * Это и есть «badge абсолютный, не дельта» в коде: вход — сумма, выход — сумма.
 */
export function badgeCount(unreadTotal) {
    if (!Number.isFinite(unreadTotal) || unreadTotal <= 0)
        return 0;
    return Math.floor(unreadTotal);
}
/**
 * Ставит/снимает платформенный badge по суммарному числу. `total===0` → `clearAppBadge()`
 * (чистая иконка), иначе `setAppBadge(count)`. Деградация (§4.6): нет соответствующего метода в
 * `api` → no-op без исключения (часть браузеров, iOS<16.4 вне standalone). Возвращает фактически
 * применённое число (для наблюдаемости/тестов согласованности «badge = суммарные»).
 */
export async function applyBadge(api, unreadTotal) {
    const count = badgeCount(unreadTotal);
    if (count === 0) {
        if (typeof api.clearAppBadge === 'function') {
            await api.clearAppBadge();
        }
        else if (typeof api.setAppBadge === 'function') {
            // Нет clearAppBadge, но есть setAppBadge: setAppBadge(0) тоже снимает badge (W3C).
            await api.setAppBadge(0);
        }
        return 0;
    }
    if (typeof api.setAppBadge === 'function') {
        await api.setAppBadge(count);
    }
    return count;
}
//# sourceMappingURL=badge.js.map